import { Order } from 'entities/orders';
import { SyntheticEvent, useCallback, useMemo, useState } from 'react';

const MAX_SHOW_TABLES = 3;

export const useOrderTables = (order: Order) => {
	const tables = useMemo(() => {
		return (
			order?.appointment?.resources?.map(resource => resource.name) || []
		);
	}, [order]);

	const [isShowAllTables, setShowAllTables] = useState(false);

	const isOverflowTables =
		tables.length > MAX_SHOW_TABLES && !isShowAllTables;
	const overflowTablesCount = tables.length - MAX_SHOW_TABLES;

	const showAllTables = useCallback((event: SyntheticEvent) => {
		event.stopPropagation();
		setShowAllTables(true);
	}, []);

	const showTables = useMemo(() => {
		if (isShowAllTables) {
			return tables;
		}

		return tables.slice(0, MAX_SHOW_TABLES);
	}, [tables, isShowAllTables]);

	return {
		isOverflowTables,
		overflowTablesCount,
		showAllTables,
		showTables,
		isShowAllTables,
	};
};
